module.exports = __webpack_public_path__ + "img/list-dark.33e5dcf6.svg";